import {Component, Input, OnInit} from '@angular/core';
import {FeatureSectionItemComponent} from "../feature-section-item/feature-section-item.component";
import {DragScrollDirective} from "../../../directives/drag-scroll.directive";
import {TemplateComponent} from "../../template/template.component";
import {Pages} from "../../../dto/Pages";
import {NgForOf, NgIf} from "@angular/common";
import {SuccessStoryItemComponent} from "../success-story-item/success-story-item.component";

@Component({
  selector: 'app-feature-section',
  standalone: true,
  imports: [
    FeatureSectionItemComponent,
    DragScrollDirective,
    NgForOf,
    SuccessStoryItemComponent,
    NgIf
  ],
  templateUrl: './feature-section.component.html',
  styleUrl: './feature-section.component.css'
})
export class FeatureSectionComponent extends TemplateComponent implements OnInit{
  loaded:boolean=false;
  @Input() title: string=$localize`:@@Searchia Search and Discovery Features:Searchia Search and Discovery Features`;
  ngOnInit() {
    this.loadPageData();
  }
  pages:Array<Pages>= new Array<Pages>();
  right(items: HTMLDivElement) {
    // @ts-ignore
    let tmp = items.children[0].offsetWidth;
    console.log(tmp);
    items.scrollBy({
      left: tmp,
      top: 0,
      behavior: 'smooth'
    });
    items.onscrollend=(event)=>{
      if (this.getDirection() == 'rtl') {
        if((items.scrollLeft*-1)<tmp)
          items.scrollLeft=0;
      }

      items.click();
    }
  }
  left(items: HTMLDivElement) {
    // @ts-ignore
    let tmp = items.children[0].offsetWidth;
    items.scrollBy({
      left: tmp*-1,
      top: 0,
      behavior: 'smooth'
    });
    items.onscrollend=(event)=>{
      // if (this.getDirection() == 'ltr') {
      //   if((items.scrollLeft*-1)<tmp)
      //     items.scrollLeft=0;
      // }
      items.click();
    }
  }


  loadPageData() {
    this.global.progressBar = true;
    var observable = this.restBack.doGet("lnd/site/get_page_list?" +
        "page=0" +
        "&nrpp=6" +
        "&type=FEATURE" +
        "" );
    observable.subscribe({
      next: (res: string) => {
        if (res["status"] == 200) {
          this.pages = res["entity"];


        }
        return res;
      },
      error: (e) => {
        this.messageService.clear();
        this.messageService.add({
              severity: 'error',
              summary: $localize`:@@Error:Error`,
              detail: $localize`:@@Server Timout Det:Server Timout Det`
            }
        );
      },
      complete: () => {
        this.loaded=true;
        this.global.progressBar = false;
      }
    });
  }

    goToFeatursPage() {
        this.route.navigate(["/features"]);
    }

  protected readonly document = document;
}
